import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useAnrokEnabled } from '../../../../../../hooks/requests/integrations/anrok/use-anrok-enabled';
import { useActivatedIntegration } from '../../../../../../hooks/use-activated-integration';
import { ProductAnrokSelector } from './ProductAnrokSelector';
import { ProductMarketplaceSelector } from './ProductMarketplaceSelector';
import { ProductNetSuiteSelector } from './ProductNetSuiteSelector';
import { QuickBooksProductSelector } from './QuickBooksProductSelector';
import { XeroProductSelector } from './XeroProductSelector';

export type ProductIntegrationSelectorsProps = {
  /** ERP product selectors (NetSuite, QuickBooks, Xero, Marketplace). */
  showErpSelectors?: boolean;
  /** Anrok tax-product id field. */
  showAnrok?: boolean;
};

/**
 * Shared ERP/tax integration selector block for the modify panels. NetSuite,
 * QuickBooks and Xero self-guard on their connection; Marketplace and Anrok do
 * not, so they keep an explicit connection check here.
 */
export function ProductIntegrationSelectors({
  showErpSelectors = true,
  showAnrok = true,
}: ProductIntegrationSelectorsProps) {
  const isAnrokConnected = useAnrokEnabled();
  const isConnactConnected = useActivatedIntegration(INTEGRATION_PROVIDERS.connact);

  return (
    <>
      {showErpSelectors && (
        <>
          <ProductNetSuiteSelector />
          <QuickBooksProductSelector />
          <XeroProductSelector />
          {isConnactConnected && <ProductMarketplaceSelector />}
        </>
      )}
      {showAnrok && isAnrokConnected && <ProductAnrokSelector />}
    </>
  );
}
